module.exports = __webpack_public_path__ + "img/motores_y_bombas.31dd4644.jpg";